export const types = {
    REGISTER_ACCORDION: 'REGISTER_ACCORDION',
    CHANGE_DISPLAYED_ACCORDION: 'CHANGE_DISPLAYED_ACCORDION',
    DEREGISTER_ACCORDION: 'DEREGISTER_ACCORDION',
};
// Initial State
const state = {
    accordions: [],
};

// Getters
const getters = {
    isOpen: state => index => state.accordions[index],
};

// Actions
const actions = {
    register: ({state, commit, dispatch}, keepClosed = false) => {
        commit(types.REGISTER_ACCORDION);
        const index = state.accordions.length - 1;
        // If nothing is open
        if (!keepClosed && !(~state.accordions.indexOf(true))) {
            return dispatch('setOpen', index).then(() => index);
        }
        return index;
    },
    setOpen: ({commit}, index) => commit(types.CHANGE_DISPLAYED_ACCORDION, index),
    deregister: ({commit, dispatch, state}, index) => {
        commit(types.DEREGISTER_ACCORDION, index);
        if (!(~state.accordions.indexOf(true))) {
            return dispatch('setOpen', state.accordions.indexOf(false));
        }
    },
    openNext({commit, state}, index) {
        let lastIndex = state.accordions.length - 1;
        if (index === lastIndex) {
            // Open previous
            return commit(types.CHANGE_DISPLAYED_ACCORDION, index - 1);
        }
        // Open next
        return commit(types.CHANGE_DISPLAYED_ACCORDION, index + 1);
    }
};

// Mutations
const mutations = {
    [types.REGISTER_ACCORDION](state) {
        state.accordions.push(false);
    },
    [types.CHANGE_DISPLAYED_ACCORDION](state, index) {
        state.accordions = state.accordions.map((show, accordionIndex) => accordionIndex === index);
    },
    [types.DEREGISTER_ACCORDION](state, index) {
        delete state.accordions[index];
    },
};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/accordion.js